import {Table, Form, Space, Radio, Badge, Flex } from 'antd'
import React, { useEffect, useState } from 'react'
import InvoiceCheck from './InvoiceCheck';
import Copy from '../../cpn/Copy';
import ReportCheck from '../../document/report/ReportCheck';
import classes from './invoice.module.css';
import StateTag from '../../cpn/StateTag';
import Icon from '../../cpn/Icon';
import InvoiceEditReportEdit from './InvoiceEditReportEdit';
import InvoiceEdit from './InvoiceEdit';
function InvoiceListSubmitted(props) {
    const [form] = Form.useForm();
    const [list,setList] = useState([]);   
    const [query, setQuery] = useState({
      "kpsq_state": '',     
  });
  useEffect(() => {
    if (props.invoiceList) {
        let arr = props.invoiceList.filter((item) => ((item.kpsq_state === '2' || item.kpsq_state === '3' || item.kpsq_state === '4' || item.kpsq_state === '5' || item.kpsq_state === '6') && item.kpsq_uid === props.yh_id) && item.kpsq_uid === props.yh_id);      
        if(query.kpsq_state){
            if(query.kpsq_state === '5'){
            arr = arr.filter((item) => item.kpsq_state === '5' || item.kpsq_state === '6');
            }else{
            arr = arr.filter((item) => item.kpsq_state === query.kpsq_state);
            }
        }      
        arr = arr.map((item) => ({
            ...item,
            key: item.key || item.kpsq_id
        }));
        const unread = arr.filter(item => item.kpsq_state === '5');
        const read = arr.filter(item => item.kpsq_state === '2' || item.kpsq_state === '3' || item.kpsq_state === '4' || item.kpsq_state === '6');
        read.sort((a, b) => new Date(b.kpsq_state_time) - new Date(a.kpsq_state_time));
        const sortedArr = [...unread, ...read];
        setList(sortedArr);
    }
}, [props.invoiceList, query.kpsq_state, props.yh_id])
    
    const columns = [    
        {
            title: '开票项目',
            dataIndex: 'kpsq_kh_name',
            width: '12%',
            key: 'kpsq_kh_name',         
            render: (text, record) =>{if(record.kpsq_state === '4'){
                if(record.kpsq_bzd_id){
                    return <InvoiceEditReportEdit
                        kpsq_id={record.key} 
                        yh_id={props.yh_id}
                        yh_name={props.yh_name}
                        kpsq_bzd_id={record.kpsq_bzd_id}
                        kpsq_bzd_name={record.kpsq_bzd_name}
                        kpsq_kh_id={record.kpsq_kh_id}
                        kpsq_kh_name={record.kpsq_kh_name}
                        kpsq_state={record.kpsq_state}
                        qy_id={props.qy_id}
                        qy_name={props.qy_name}
                    />
                }else{
                    return <InvoiceEdit
                        kpsq_id={record.key} 
                        yh_id={props.yh_id}
                        yh_name={props.yh_name}
                        kpsq_bzd_id={record.kpsq_bzd_id}
                        kpsq_bzd_name={record.kpsq_bzd_name}
                        kpsq_kh_id={record.kpsq_kh_id}
                        kpsq_kh_name={record.kpsq_kh_name}
                        kpsq_state={record.kpsq_state}
                        qy_id={props.qy_id}
                        qy_name={props.qy_name}
                    />
                }
               
            }else{
                return <InvoiceCheck
                                        type='button'
                                        kpsq_id={record.key} 
                                        yh_id={props.yh_id}
                                        yh_name={props.yh_name}
                                        kpsq_bzd_id={record.kpsq_bzd_id}
                                        kpsq_price={record.kpsq_price}
                                        kpsq_content={record.kpsq_content}
                                        kpsq_date={record.kpsq_date}
                                        kpsq_date_end={record.kpsq_date_end}
                                        kpsq_bzd_name={record.kpsq_bzd_name}
                                        kpsq_bzd_danhao={record.kpsq_bzd_danhao}
                                        kpsq_type_id={record.kpsq_type_id}
                                        kpsq_type_name={record.kpsq_type_name}
                                        kpsq_kh_id={record.kpsq_kh_id}
                                        kpsq_kh_name={record.kpsq_kh_name}
                                        qy_id={props.qy_id}
                                        qy_name={props.qy_name}
                                        kpsq_num={record.kpsq_num}
                                        kpsq_amount={record.kpsq_amount}
                                        kpsq_state={record.kpsq_state}
                                        kpsq_bm_id={record.kpsq_bm_id}
                                        kpsq_bm_name={record.kpsq_bm_name}
                                        kpsq_khyhzh_id={record.kpsq_khyhzh_id}
                                        kpsq_khyhzh_name={record.kpsq_khyhzh_name}
                                        kpsq_image_name={record.kpsq_image_name}
                                        kpsq_image_file={record.kpsq_image_file}
                                        kpsq_ctime={record.kpsq_ctime}
                                        kpsq_uid={record.kpsq_uid}
                                        listType='submitted'
                                    />
                }
        }
        },
        {
            title: '开票金额',
            dataIndex: 'kpsq_amount',
            width: '10%',
            key: 'kpsq_amount',   
            render: (text, record) => <span style={{ color: '#FF6600' }}>￥{Number(text).toLocaleString('zh-CN', {
                minimumFractionDigits: 2,
                maximumFractionDigits: 2
            })}</span>
        },
        {
            title: '开票项目',
            dataIndex: 'kpsq_name',
            key:'kpsq_name',
            render:(text, record) => <Copy title={record.kpsq_name}/>
        },   
        {
            title: '团队名称',
            width: '10%', 
            dataIndex:"kpsq_bzd_name",
            key:'kpsq_bzd_name',
            render:(text,record) => <ReportCheck dsbzd_id={record.kpsq_bzd_id} dsbzd_name={record.kpsq_bzd_name} qy_id={props.qy_id} yh_id={props.yh_id} yh_name={props.yh_name} />
        },      
        {
            title: '审批时间',
            dataIndex: 'kpsq_state_time',
            width: '10%',
            key: 'kpsq_state_time',             
        },
        {
            title: '状态',
            dataIndex: 'kpsq_state',
            width: '5%',
            key: 'kpsq_state',            
            render:(text) => <StateTag state={text} />
        },       
        {
            title: '编号',
            dataIndex: 'key',
            width: '5%',
            key: 'key',                        
        },       
    ]
    return (
        <>                            
            <Flex style={{ marginBottom: "10px" }} align='center' justify='space-between'>
                <Form
                    layout='inline'
                    name='form_invoice_list_submitted'
                    form={form}
                    initialValues={{                        
                        kpsq_state: query.kpsq_state ? query.kpsq_state : '',                        
                    }}
                    onFinish={(values) => {
                        console.log(values);
                        // Serialize dayjs objects to strings before storing
                        const serializedValues = {
                            ...values,
                            dsbzd_state: values.dsbzd_state ? values.dsbzd_state : '',
                            dsbzd_kh_id: values.dsbzd_kh_id ? values.dsbzd_kh_id : '',
                            dsbzd_content: values.dsbzd_content ? values.dsbzd_content : '',
                        };
                        
                        localStorage.setItem('jtg-ld_reportList_dsbzd_state', JSON.stringify(serializedValues.dsbzd_state));
                        localStorage.setItem('jtg-ld_reportList_dsbzd_kh_id', JSON.stringify(serializedValues.dsbzd_kh_id));
                        localStorage.setItem('jtg-ld_reportList_dsbzd_content', JSON.stringify(serializedValues.dsbzd_content));
                        setQuery(prev => ({ 
                            ...prev, 
                            dsbzd_state: serializedValues.dsbzd_state, 
                        }));
                    }}
                >
                    <Form.Item 
                        name='dsbzd_state' 
                        label={props.label} 
                        required={props.required} 
                        style={props.style} 
                        wrapperCol={props.wrapperCol}
                        noStyle

                    >
                        <Radio.Group 
                            onChange={(e) => {
                                setQuery(prev => ({ 
                                    ...prev, 
                                    kpsq_state: e.target.value,                                     
                                }));
                                localStorage.setItem('jtg-ld_loanList_kpsq_state', JSON.stringify(e.target.value));
                            }}
                            buttonStyle='solid'
                            optionType="button" 
                        >
                            <Radio value='' >全部</Radio>
                            <Radio value='2' >待审批</Radio>
                            <Radio value='3' >审批中</Radio>                
                            <Badge count={props.invoiceRejectedNum} style={{zIndex:'9999'}}>
                                <Radio value='4' >已驳回</Radio>
                            </Badge>
                            <Badge count={props.invoiceEndNeedReadNum} style={{zIndex:'9999'}}>
                                <Radio value='5' >已结束</Radio>
                            </Badge>
                           
                        </Radio.Group>        
                    </Form.Item>                    
                    <Form.Item style={{marginLeft: 10}}>
                        <Space align='center' size='middle'>
                            <Icon type='search' onClick={() => {form.submit()}}/>
                            <Icon type='reset'
                                onClick={() => {
                                    form.resetFields()
                                    localStorage.setItem('jtg-ld_loanList_kpsq_state', JSON.stringify(''))
                                    setQuery({
                                        "kpsq_state": '',                                        
                                    })
                                    form.setFieldsValue({
                                        kpsq_content: null,
                                        kpsq_kh_id: null,
                                        kpsq_bzd_danhao: null,
                                    });
                                }}
                            />
                        </Space>
                    </Form.Item>
                </Form>  
            </Flex>
            <Table 
                className={classes.orangeHeader}
                dataSource={list}
                columns={columns}
                pagination={false}
                size='small'
                bordered
                rowKey="key"
                summary={pageData => {
                    const total = pageData.reduce((sum, row) => sum + Number(row.kpsq_amount || 0), 0);
                    return (
                        <Table.Summary.Row>
                            <Table.Summary.Cell key="summary-0" index={0}></Table.Summary.Cell>
                            <Table.Summary.Cell key="summary-1" index={1} colSpan={1}>
                                <span style={{color:'#FF6600'}}>合计：￥{Number(total).toLocaleString('zh-CN', {
                                                                minimumFractionDigits: 2,
                                                                maximumFractionDigits: 2
                                                            })}</span>
                            </Table.Summary.Cell>
                            <Table.Summary.Cell key="summary-2" index={2} colSpan={columns.length - 2} />
                        </Table.Summary.Row>
                    );
                }}
                locale={{
                    emptyText: '暂无开票申请数据' // This will display text when the table is empty
                }}
            />
        </>
    )
}

export default InvoiceListSubmitted